import { styled } from "@mui/material/styles";
import { Box, Grid, IconButton } from "@mui/material";

export const StyledButtonWaze = styled(Box)({
  minWidth: 40,
});

export const StyledButtonWazeImage = styled("img")({
  height: 30,
});

export const StyledLastGridItem = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    order: -1,
  },
}));

export const StyledDeleteButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  bottom: theme.spacing(2),
  right: theme.spacing(2),
}));
